<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">DEATH MARCH THROUGH RUSSIA</span></h1>
<p class="subtitle"><span class="bold">My Journey from Soldier to Prisoner of War</span></p>
<p class="author"><em class="italic"><span class="bold">Klaus Willmann</span></em></p>
<p class="center">(As told to him by Lothar Herrmann)</p>
<p class="center1"><em class="italic">Foreword by</em></p>
<p class="center2"><span class="bold">Roger Moorhouse</span></p>
<p class="center1"><em class="italic">Translated by</em></p>
<p class="center2"><span class="bold">Eva Burke</span></p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?43278c46